import { EXPERIMENTS_PROVIDER as i } from "@ado/experiment-library";
import { NAVIGATION_STATE as o } from "./index2.js";
import { createCountryCodeProvider as n } from "@ado/location-library";
const a = "Notary_Navigation_LD_US_23-03", s = "NOTARY", y = "N";
class S {
  constructor(t = o, e = n(), r = i) {
    this.navigationState = t, this.countryCodeProvider = e, this.experimentsProvider = r;
  }
  async setStateContent(t) {
    const e = t.menuCategories, r = e.filter(
      this.isNotNotaryOnlineCategory.bind(this)
    );
    if (!(e.length !== r.length)) {
      this.navigationState.set(t);
      return;
    }
    this.trySetStateWithoutNotaryIfNotPresentAlready(
      r
    ), await this.trySetStateWithNotary(e) || this.setMenuCategoriesInState(r);
  }
  async trySetStateWithNotary(t) {
    return await this.shouldShowNotaryOnlineCategory() ? (this.setMenuCategoriesInState(t), !0) : !1;
  }
  trySetStateWithoutNotaryIfNotPresentAlready(t) {
    return this.navigationState.get().menuCategories.some(this.isNotaryOnlineCategory.bind(this)) ? !1 : (this.setMenuCategoriesInState(t), !0);
  }
  setMenuCategoriesInState(t) {
    this.navigationState.set({
      menuCategories: t
    });
  }
  async shouldShowNotaryOnlineCategory() {
    const t = this.countryCodeProvider.provideCountryCode() ?? "";
    return (await this.experimentsProvider.getExperiment({
      experimentName: a,
      countryCode: t
    }))?.variation === y;
  }
  isNotNotaryOnlineCategory(t) {
    return !this.isNotaryOnlineCategory(t);
  }
  isNotaryOnlineCategory(t) {
    return t.code === s;
  }
}
export {
  a as NOTARY_NAVIGATION_LINK_EXPERIMENT,
  S as NavigationStateAlterationInterceptorForNotary,
  y as VARIATION_TO_SHOW_NOTARY
};
//# sourceMappingURL=index3.js.map
